module.exports = __webpack_public_path__ + "Icono_SurtirCX_512px.png";